class CountdownTimer extends HTMLElement {
    constructor()  {
        super();

        this.interval = +this.dataset.interval;
        this.initialStartDate = this.dataset.initialStartDate;
        this.intervalDays = +this.interval;
        this.intervalMs = this.intervalDays * 24 * 60 * 60 * 1000;

        this.startDate = new Date(`${this.initialStartDate}T00:00:00`);
        this.endDate = this.appendDaysToDate(this.startDate, this.intervalDays);

        this.updatedDates = this.updateDates()
    }

    connectedCallback() {
        this.startDate = this.updatedDates[0]
        this.endDate = this.updatedDates[1]

        this.displayDates(this.startDate, this.endDate);

        this.updateCountdown();
        setInterval(this.updateCountdown.bind(this), 1000);
    }

    updateCountdown() {
        const now = new Date().getTime();

        if (now >= this.endDate) {
            this.updatedDates = this.updateDates()
            this.startDate = this.updatedDates[0]
            this.endDate = this.updatedDates[1]
            this.displayDates(this.startDate, this.endDate);
        }

        const timeLeft = this.endDate - now;

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        this.querySelector('#days').innerHTML = days;
        this.querySelector('#hours').innerHTML = hours;
        this.querySelector('#minutes').innerHTML = minutes;
        this.querySelector('#seconds').innerHTML = seconds;
    }

    updateDates() {
        const cycles = Math.floor((new Date().getTime() - this.startDate.getTime()) / this.intervalMs);

        if (cycles > 0) {
            this.startDate = this.appendDaysToDate(this.startDate, this.intervalDays * cycles);
            this.endDate = this.appendDaysToDate(this.startDate, this.intervalDays);
        }

        return [this.startDate, this.endDate];
    }

    appendDaysToDate(date, days) {
        let newDate = new Date(date);
        return new Date(newDate.setDate(newDate.getDate() + days));
    }

    displayDates(startDate, endDate) {
        const sectionTitle = this.querySelector("h2");
        if (!sectionTitle) return;

        const { pattern } = sectionTitle.dataset;

        sectionTitle.innerHTML = pattern
          .replace('[start]', this.dateFormatter(startDate))
          .replace('[end]', this.dateFormatter(endDate));
    }

    dateFormatter(date) {
        let day = date.getDate();
        let month = date.getMonth() + 1;
        return `${day}.${month}`;
    }
}

if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
}